
import { RenderHtml } from "@components/html";
import { wrapWordTag } from '@lib/utils';
import { Suspense } from "react";
import { AdDividerCta } from "src/blocks/ad-divider-cta";
import { AffiliateLinks } from "src/blocks/affiliate-links";
import { CustomCollection } from "src/blocks/custom-collections";
import { PostCollections } from "src/blocks/post-collections";
import { GoogleAds } from "src/blocks/google-ads";
import { WeeklyTopTenList } from "src/blocks/weekly-top-ten-list";
import { YoutubePlaylist } from "src/blocks/youtube-playlist";
import { YoutubeSearch } from "src/blocks/youtube-search";
import { YoutubeVideo } from "src/blocks/youtube-video";
import { TaxonomyCollections } from "src/blocks/taxonomy-collections";
import { IssueArtworkCollections } from "src/blocks/issue-cover-art-collections";
import { MonumetricAds } from "src/blocks/monumetric-ads";

interface DynamicBlockProps {
    className?: string;
    search?: string;
    blocks: any;
}

const defaultProps: DynamicBlockProps = {
    className: "",
    search: "",
    blocks: [],
};

// wp components map
const components: any = {
    "acf/post-collection": PostCollections,
    "acf/custom-collection": CustomCollection,
    "acf/youtube-playlist": YoutubePlaylist,
    "acf/youtube-search": YoutubeSearch,
    "acf/youtube-video": YoutubeVideo,
    "acf/weekly-top-ten": WeeklyTopTenList,
    "acf/taxonomy-collection": TaxonomyCollections,
    "acf/google-ad": GoogleAds,
    "acf/monumetric-ad": MonumetricAds,
    "acf/ad-divider-cta": AdDividerCta,
    "acf/affiliate-links": AffiliateLinks,
    "acf/issue-coverart": IssueArtworkCollections,
    "core/paragraph": RenderHtml,
    "core/image": RenderHtml,
    "core/separator": RenderHtml,
    "core/heading": RenderHtml,
    "core/list": RenderHtml,
};

const DynamicBlock = ({ blocks, className, search }) => {

    const blockRender = blocks
        ?.map((block, index) => {
            if (block?.blockName === null) {
                return null;
            }
            const DynamicComponent = components[block?.blockName];

            const searchMarkup = search
                ? wrapWordTag(search, block?.html)
                : block?.html;

            return <DynamicComponent
                key={`${block}-${index}`}
                attrs={block?.attrs}
                markup={searchMarkup}
                className={className}
                results={block?.results}
                details={block?.details}
                // TODO: Need To Refactor How Attributes Are Passed.
                {...block?.attrs}
            />;
        }) || [];

    return <Suspense fallback={<h1>Still Loading…</h1>}>{blockRender}</Suspense>;
};

DynamicBlock.defaultProps = defaultProps;

export default DynamicBlock;
